import { first } from 'rxjs/operators';
import { InboxService, Inbox } from '@app/_components/inbox';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InboxComponent } from '../inbox/inbox.component';
import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import { AlertService, AuthenticationService } from '@app/_services';
import {LazyLoadEvent, MessageService, ConfirmationService, FilterService, MenuItem, TreeNode, SelectItem, FilterMatchMode} from 'primeng/api';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {ImapUserMappingService} from '@app/_components/imap-user-mapping/imap-user-mapping.service';
import {ImapConfigurationService} from '@app/_components/imap-configuration/imap-configuration.service';
import {Msg, MsgService} from '@app/_components/msg';
import {TaskListComponent} from '@app/_components/task/task-list/task-list.component';
import {InboxSmsComponent} from '@app/_components/inbox/inbox-sms/inbox-sms.component';
import {ImapConfiguration} from '@app/_components/imap-configuration/imap-configuration';
import {InboxMailSMsComponent} from '@app/_components/inbox/inbox-mail-sms/inbox-mail-sms.component';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-inbox-list-guest',
    templateUrl: './inbox-list-guest.component.html',
    styleUrls: ['./inbox-list-guest.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class InboxListGuestComponent implements OnInit {
	cols: { field: string; header: string; }[];
	tableData: any[] = [];
	allInboxes: any;
	childInboxesData: any;
	currentUser: User;
	currentUserSubscription: Subscription;
  mailBoxes: SelectItem[];
  selectedmailbox = '3';
  selectedNode: TreeNode;
  items: MenuItem[];
  mailBoxIds: any[] = [9,12,15,18];
  selectedMails: any[] = [];
  private inobxes: any[];
  msg: Msg;
  selectedMailEntry: Inbox;
  selectAllCheckbox = false;
  @Input() msgTopic: number;
  @Input() msgTopicId: number;
  @Input() orderId: number;
  @Input() realtorProfileId: number;
  @Input() msgTemplateData: MsgTemplateData;
  constructor(
		private inboxService: InboxService,
		private imapConfigurationService: ImapConfigurationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private dialog: MatDialog,
		public datePipe: DatePipe,
    private msgService: MsgService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef
	) {
		this.statuses = inboxService.statuses;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
		try {
      this.mailBoxes = [];

      this.mailBoxes.push({ label: 'Inbox', icon: 'pi pi-envelope', styleClass: 'p-button-info', value: '3' });
      this.mailBoxes.push({ label: 'Sentbox', icon: 'pi pi-telegram', styleClass: 'p-button-info',  value: '2' });
      this.mailBoxes.push({ label: 'Draft', icon: 'pi pi-telegram', styleClass: 'p-button-info',  value: '1' });
      this.mailBoxes.push({ label: 'Outbox', icon: 'pi pi-exclamation-triangle', styleClass: 'p-button-info', value: '5' });
      this.mailBoxes.push({ label: 'Archived', icon: 'pi pi-arrow-circle-down', styleClass: 'p-button-info', value: '0' });

		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
    try {
      if ( this.route?.snapshot?.params['msgTopic']){
        this.msgTopic = this.route.snapshot.params['msgTopic'];
      }
    }catch (e){}
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	inboxs: any[] = [];
	parents: any[] = [];
	children: any[] = [];
	inbox: Inbox;
  mailselectCheckBox = false;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	inboxNames: any;
	columns: any[] = [
		{ field: 'senderName', header: 'Sender Name', width: 'auto' },
		{ field: 'senderEmail', header: 'Sender Email', width: 'auto' },
		{ field: 'subject', header: 'subject', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 1 });

      this.items = [
        {
          label: 'Assign Task',
          icon: 'pi pi-fw pi-plus',
          command: (event) => this.openCreatTask(this.selectedNode.data)
        },
        {
          separator: true
        },
        {
          label: 'Archive',
          icon: 'pi pi-fw pi-download',
          command: (event) => this.archiveMsg(this.selectedNode.data)
        }
      ];

		}
		catch (error) {
			console.log('Error: ' + error);
		}

	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.inboxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;
			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-inbox-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			const pageNumber = Math.round(event.first / event.rows);
			if(this.orderId){
				this.inboxService.findGuestCommByFilter(
					pageNumber, event.rows,
					event.sortField,
					event.sortOrder,
					event.multiSortMeta,
					event.globalFilter,
					event.filters, this.orderId).pipe(first()).subscribe(
	
						(res: any) => {
							this.datasource = res.data;
							this.recordTotal = res.page.recordTotal;
							this.inboxs = [];
							this.inbox = res.data.msgs;
							this.allInboxes = res.data.msgs;
				this.selectedMailEntry = null;
							for (let i = 0; i < res.data.msgs.length; i++) {
				  let entry = res.data.msgs[i];
				  if (!res.data.msgs[i].emailHtml && res.data.msgs[i].emailText) {
					res.data.msgs[i].emailHtml = res.data.msgs[i].emailText;
				  }
	
				  let nameInitial: any = '';
				  try{
				  if (entry?.imapConfigurationAPI?.name) {
					nameInitial = Array.from(entry?.imapConfigurationAPI?.name)[0];
					nameInitial = nameInitial.toUpperCase();
				  } else {
					nameInitial = Array.from(entry?.msgRecipientAPIList[0]?.email)[0];
				  }
				  entry.nameInitial = nameInitial;
				  entry.receiverEmail = entry?.msgRecipientAPIList[0]?.email;
				}catch (e) {
	
				  }
				  try{
					if (entry?.status === 2) {
					  entry.dateCreation = entry.sentDate;
					}
					if (entry?.status === 3) {
					  entry.dateCreation = entry.receivedDate;
					}
					if( !entry.dateCreation){
					  entry.dateCreation = entry.createDate;
					}
				  }catch (e) {
	
				  }
	
									let node = {
										data: entry,
										leaf: false
									};
									this.inboxs.push(node);
							}
							console.log(JSON.stringify(res.page));
						},
						(err: any) => {
							console.log('reviews list error!: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.loading = false; }
					);
			}
			if(this.realtorProfileId){
				this.inboxService.findGuestCommForRealtorByFilter(
					pageNumber, event.rows,
					event.sortField,
					event.sortOrder,
					event.multiSortMeta,
					event.globalFilter,
					event.filters, this.realtorProfileId).pipe(first()).subscribe(
	
						(res: any) => {
							this.loading = false;
							this.datasource = res.data;
							this.recordTotal = res.page.recordTotal;
							this.inboxs = [];
							this.inbox = res.data.msgs;
							this.allInboxes = res.data.msgs;
				this.selectedMailEntry = null;
							for (let i = 0; i < res.data.msgs.length; i++) {
				  let entry = res.data.msgs[i];
				  if (!res.data.msgs[i].emailHtml && res.data.msgs[i].emailText) {
					res.data.msgs[i].emailHtml = res.data.msgs[i].emailText;
				  }
	
				  let nameInitial: any = '';
				  try{
				  if (entry?.imapConfigurationAPI?.name) {
					nameInitial = Array.from(entry?.imapConfigurationAPI?.name)[0];
					nameInitial = nameInitial.toUpperCase();
				  } else {
					nameInitial = Array.from(entry?.msgRecipientAPIList[0]?.email)[0];
				  }
				  entry.nameInitial = nameInitial;
				  entry.receiverEmail = entry?.msgRecipientAPIList[0]?.email;
				}catch (e) {
					this.loading = false;
				  }
				  try{
					if (entry?.status === 2) {
					  entry.dateCreation = entry.sentDate;
					}
					if (entry?.status === 3) {
					  entry.dateCreation = entry.receivedDate;
					}
					if( !entry.dateCreation){
					  entry.dateCreation = entry.createDate;
					}
				  }catch (e) {
						this.loading = false;
				  }
	
									let node = {
										data: entry,
										leaf: false
									};
									this.inboxs.push(node);
							}
							console.log(JSON.stringify(res.page));
						},
						(err: any) => {
							this.loading = false;
							console.log('reviews list error!: ' + JSON.stringify(err));
							// this.alertService.error(err);
						},
						() => { this.loading = false; }
					);
			}
			

			if (this.datasource) {
				this.inboxs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
      this.loading = false;
		}
	}
	onNodeExpand1(event: any) {
		const node = event.node;
		const childInboxes = [];
		this.inboxService.findChildMails(node.data.msgId).pipe(first()).subscribe(
			(res: any) => {
				this.childInboxesData = res.data.msgs;
				for (let i = 0; i < this.childInboxesData.length; i++) {
          let entry = res.data.msgs[i];
          let imapConfId = '', imapConfName = '';
          if ( res.data.msgs[i].imapConfigurationAPI){
            imapConfId = res.data.msgs[i].imapConfigurationAPI.imapConfigurationId;
            imapConfName = this.childInboxesData[i].imapConfigurationAPI.name;
          }
          let nameInitial: any = '';
          if ( entry?.imapConfigurationAPI?.name){
            nameInitial = Array.from(entry?.imapConfigurationAPI?.name)[0];
            nameInitial = nameInitial.toUpperCase();
          }
					let node = {
						data: {
							msgId: this.childInboxesData[i].msgId,
							inboxName: imapConfName,
							status: this.getStatusName(this.childInboxesData[i]),
							senderName: this.childInboxesData[i].senderName,
							senderEmail: this.childInboxesData[i].senderEmail,
							subject: this.childInboxesData[i].subject,
							receivedDate: this.datePipe.transform(this.childInboxesData[i].receivedDate, 'MMM d, y, h:mm:ss a'),
							emailHtml: this.childInboxesData[i].emailHtml,
							imapConfigId: imapConfId,
              taskAPIList: this.childInboxesData[i].taskAPIList,
              ischild: true,
              nameInitial: nameInitial
						},
					};
					childInboxes.push(node);
				}
				node.children = childInboxes;
				this.inboxs = [...this.inboxs];
			},
			(err: any) => {
				console.log('reviews list error!: ' + JSON.stringify(err));
				this.alertService.error(err);
			},
			() => { this.loading = false; }
		);
	}
  onNodeExpand(event: any) {
    const node = event.node;
    let subtaskList = [];
    let msges = node?.data?.children;
    for (let i = 0; i < msges.length; i++) {
      /* if ( this.currentUser.userId === tasks[i]?.assignedTo?.userId || this.currentUser.userId === tasks[i]?.createdBy?.userId ||
         this.currentUser.userId === tasks[i]?.ownedBy?.userId ) */
      msges[i].ischild = true;
      let entry = {
        'data': msges[i],
        leaf: false,
      };
      subtaskList.push(entry);

    }
    node.children = subtaskList;
    this.inboxs = [...this.inboxs];
  }
	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(inbox: Inbox) {
		try {
			this.formLoading = true;
			this.inboxService.update(inbox)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.inboxs.map((inbox, i) => {
							if (inbox.msgId === res.data.msg.msgId) {
								this.inboxs[i] = res.data.inbox;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(inbox: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(inbox));

			this.formLoading = true;
			this.inboxService.delete(inbox.inboxId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
						this.recordTotal = this.inboxs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Inbox ' + inbox.inboxId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Inbox ' + inbox.inboxId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	refreshMails() {
		try {
			this.formLoading = true;
			this.inboxService.refresh()
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.loadLazy(this.lazyLoadEvent);
						this.formLoading = false;
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(JSON.stringify(err));
						this.formLoading = false;
					},
					() => {});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
			this.formLoading = false;
		}
	}
	/*********
	 * Add New Button for sending both mail and sms
	 *
	 */
	onOpenFormAddMailAndSMS() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'New Mail',
			msgTopicId: [this.msgTopicId],
			msgTopic: [this.msgTopic],
      msgTemplateData: this.msgTemplateData
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxMailSMsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
	}
	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'New Mail',
      		msgTopicId: this.msgTopicId,
      		msgTopic: this.msgTopic
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
	}

  onOpenFormAddForSMS() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'New SMS',
      msgTopicId: this.msgTopicId,
      msgTopic: this.msgTopic
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxSmsComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
  }


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(inbox: Inbox) {

		const dialogConfig = new MatDialogConfig();
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			inbox: inbox,
			title: 'View Inbox Mail'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateInboxCB(data);
        this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
		dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.loadLazy(this.lazyLoadEvent);

			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteInboxCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}
  openSelectedMail(inbox: Inbox) {
    this.selectedMailEntry = null;
    this.changeDetector.detectChanges(); // every time mail entry is changed component should be reloaded this is way to tell ng prime that component needs to reloaded
    if (inbox) {
      this.msgService.findById(inbox?.msgId).subscribe(
        (res: any) => {
          console.log("send message, SUCCESS: " + JSON.stringify(res));
          this.msg = res.data.msg;
          this.selectedMailEntry = res.data.msg as Inbox;
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
      );
    }
  }


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addInboxCB(inbox: Inbox) {
		console.log('Adding Inbox: ' + JSON.stringify(inbox));
		// if we don't have a inboxs array yet...
		if (!this.inboxs) {
			this.inboxs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.inboxs.unshift(inbox);

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Added', life: 3000 });
	}

	updateInboxCB(inbox: Inbox) {
		console.log('Updating Inbox: ' + JSON.stringify(inbox));
		let itemIndex = this.inboxs.findIndex((item: any) => item.inboxId === inbox.msgId);
		this.inboxs[itemIndex] = inbox;

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Updated', life: 3000 });
	}

	deleteInboxCB(inbox: Inbox) {
		console.log('Removing Inbox: ' + inbox);
		this.inboxs.splice(this.inboxs.indexOf(inbox), 1);
		this.recordTotal = this.inboxs.length;

		// no idea what this is but it is required to update the array
		this.inboxs = [...this.inboxs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Inbox ' + inbox.msgId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.inboxs ? this.first === (this.inboxs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.inboxs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(inbox: any) {
		if (inbox?.status) {
			const status = this.statuses.find((e: any) => e.value == inbox.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator() {
		return true;
	}

  loadMailBox(event: any) {
    this.loadLazy(this.lazyLoadEvent);
  }

  private openCreatTask(selectedNode: any) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let custTaskApi = {name: selectedNode.subject};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
	 purpose: 'createmailtask',
      taskApi: custTaskApi,
	  msg: selectedNode as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        dialogRef.close();
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        this.messageService.add({
          severity: 'success',
          summary: 'Task Created',
          detail: 'Task Created',
        });
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
  }

  private archiveMsg(selectedNode: TreeNode) {
    try {
      let msg  =  new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
          this.loadLazy(this.lazyLoadEvent);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  private archiveSelected() {
    for ( let j = 0; j < this.selectedMails.length; j++) {


      try {

        let msg = new Msg();
        let sel = this.selectedMails[j] as object;
        // @ts-ignore
        msg.msgId = sel?.msgId;
        msg.msgFolder = 2;  // 2 is for archive folder
        this.msgService.archiveMsg(msg).subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
          }
        );
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    this.selectAllCheckbox = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Archived',
      detail: 'Archived',
    });
    this.selectedMails = [];
    this.loadLazy(this.lazyLoadEvent);
  }
  selectAllCheckboxChanged(){
    this.selectedMails = [];
    if ( this.selectAllCheckbox){
      this.inboxs.forEach(x => {
        x.data.checkboxFlag = true;
        this.selectedMails.push(x);
      });
    }
    else{
      this.inboxs.forEach(x => {
        x.data.checkboxFlag = false;
      });
    }
  }

  getFilteredTags(tags) {
    // if filter text input is empty then load all records
    if (tags == '0') {
      delete this.lazyLoadEvent.filters.msgId;
      this.loadLazy(this.lazyLoadEvent);
    } else {
      // If records found then show filtered records
      if (tags.length > 0) {
        // if filter text input is not empty then load filtered records only
        let filteredMsgIds = [];
        tags.forEach(tag => {
          filteredMsgIds.push(tag.tagSourceId);
        });
        let activityProviderIdFilter = { 'msgId': { 'value': filteredMsgIds, 'matchMode': 'in' } };
        Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
        this.loadLazy(this.lazyLoadEvent);
      } else {
        // Display empty table as no record found with filtered input
        this.inobxes = [];
      }
    }
  }

	openViewTask(rowData: any) {
		if (rowData.taskAPIList?.length > 1) {
			const dialogConfig = new MatDialogConfig();
			// settings
			dialogConfig.width = '100%';
			dialogConfig.height = '100%';
			dialogConfig.maxWidth = '1600px';
			dialogConfig.maxHeight = '800px';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: 'Mail Tasks',
				isModal: true,
				parentMsgId: rowData.msgId,
				fromMail: true,
				showFilter: false,
				showPagination: false,
				outlineNewButton: false,
			};
			const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.width = '100vw';
			dialogConfig.height = '100vh';
			dialogConfig.maxWidth = '100vw';
			dialogConfig.maxHeight = '100vh';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.data = {
				title: 'Assign Task',
				isModal: true,
				taskApi: rowData?.taskAPIList[0],
				fromMail: false
			};

			const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
			dialogRef.componentInstance.doAdd.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.loadLazy(this.lazyLoadEvent);
					dialogRef.close();
				});
		}
	}

  getNumberOfChildMsg(msg: any) {
   /* if (!msg?.jsonChildMsg || '' === msg?.jsonChildMsg) {
      return 0;
    }
    return JSON.parse(msg?.jsonChildMsg).length;*/
    return msg?.children?.length;

  }

  mailSelectionChanged(msg: any){
	const index = this.selectedMails.findIndex(x => x.msgId === msg.msgId);
	if ( index === -1 ){
		this.selectedMails.push(msg);
	  }
	  else{
		this.selectedMails.splice(index, 1);
	  }
  }

	msgSent($event: any) {
		this.selectedMailEntry = null;
    this.loadLazy(this.lazyLoadEvent);
	}

  limitText(text: string, limit: number): string {
    if ( !text) return '';
    if (text.length > limit) {
      return text.substring(0, limit) + '...';
    }
    return text;
  }
}
